theme.Contact = (function() {
  function Contact(container) {     
    var sectionId = container.getAttribute('data-section-id');
    var hny = document.getElementById('honeypot');
    hny.innerHTML = '<input class="btn standard-width bottompad" type="submit" value="' + theme.language.contact_form_send + '" id="contactFormSubmit" />';
    document.getElementById('contactFormSubmit').onclick = function(ev){
      if (document.getElementById('contactFormNumber').value.length > 0) {
        ev.preventDefault();
      }
    }
  }
  return Contact;
})();

// STR 件名による注文番号の表示・非表示
let subtitleSelect = document.querySelector('#contactForm-件名-7808e502-9020-4e02-bd9a-cd43443e848c');

subtitleSelect.addEventListener('change', function() {
  let selValue =  this.value;
  let orderNo = document.getElementById('orderNo');
  let orderNoTxt = orderNo.children[1];
  let hideFlg = false;

  switch (selValue){
    case '':
      hideFlg = true; 
      break;
    case '5STAR MARCHEについて':
      hideFlg = true; 
      break;
    case '退会について':
      hideFlg = true; 
      break;
    case '定期販売 / 予約販売について':
      hideFlg = true; 
      break;
    case 'その他':
      hideFlg = true; 
      break;
    default:
      hideFlg = false; 
      break;
  }
  if (hideFlg) {
    orderNo.style.display = 'none';
    orderNoTxt.removeAttribute('required');
  }
  else {
    orderNo.style.display = 'block';
    orderNoTxt.setAttribute('required', '');
  }
});
// END 件名による注文番号の表示・非表示